export interface Topic {
  id: number;
  title: string;
  excerpt: string;
  tag: string;
  heat: number;
  replies: number;
  author: string;
  time: string;
  isLive?: boolean;
  badge?: string;
}

export interface RankItem {
  id: number;
  title: string;
  desc: string;
  heat: number;
  trend: "up" | "down" | "new" | "flat";
  tag: string;
}

export interface Comment {
  id: number;
  name: string;
  text: string;
  likes: number;
  time: string;
  tag: string;
  initial: string;
  tone: string;
}

export interface Thread {
  id: number;
  title: string;
  excerpt: string;
  tag: string;
  author: string;
  time: string;
  replies: number;
  likes: number;
  views: number;
  pinned?: boolean;
}

export interface Faq {
  q: string;
  a: string;
}

export const navLinks = [
  { key: "today", label: "今日热点" },
  { key: "rank", label: "热议榜单" },
  { key: "discuss", label: "讨论区" },
  { key: "comment", label: "评论区" },
  { key: "faq", label: "吃瓜百科" },
  { key: "about", label: "关于我们" },
];

export const categoryFilters = ["全部", "综艺", "恋综", "剧组", "职场", "生活", "数码"];

export const heroTopics = [
  { tag: "恋综", title: "下期心动预告流出，观众直呼太敢拍" },
  { tag: "剧组", title: "古装新剧开机路透，服化道被夸上热搜" },
  { tag: "综艺", title: "选秀节目复活赛赛制突变，网友吵翻" },
  { tag: "职场", title: "上班搭子图鉴：今天你摸鱼了吗" },
];

export const hotTopics: Topic[] = [
  {
    id: 1,
    title: "恋综嘉宾结局反转，节目组深夜放话",
    excerpt: "眼看就要大结局，最新一期爆出的反转让追更群众集体坐不住了，评论区已吵到三千楼。",
    tag: "恋综",
    heat: 982000,
    replies: 3218,
    author: "蹲后续的瓜",
    time: "8 分钟前",
    isLive: true,
    badge: "爆",
  },
  {
    id: 2,
    title: "古装剧组路透流出，服化道被夸上热搜",
    excerpt: "开机才三天，一组高清路透就冲上热议榜，网友纷纷求正片速速安排。",
    tag: "剧组",
    heat: 761000,
    replies: 2104,
    author: "片场第一排",
    time: "23 分钟前",
    badge: "热",
  },
  {
    id: 3,
    title: "打工人午餐吃瓜时间，大家都聊了什么",
    excerpt: "午休一小时，摸鱼五分钟。话题榜上最热闹的其实是办公室的每日一瓜。",
    tag: "职场",
    heat: 654000,
    replies: 1876,
    author: "午休观察员",
    time: "41 分钟前",
    isLive: true,
  },
  {
    id: 4,
    title: "选秀复活赛赛制突变，粉丝集体下场",
    excerpt: "复活名额一夜之间从三个变一个，各家粉丝纷纷下场理论，票数火速飙升。",
    tag: "综艺",
    heat: 583000,
    replies: 1693,
    author: "今天不投了",
    time: "1 小时前",
    badge: "热",
  },
  {
    id: 5,
    title: "数码博主实测新机翻车？现场还原真相",
    excerpt: "一条实测视频引发争议，博主连夜补测，评论区两边人马各执一词。",
    tag: "数码",
    heat: 447000,
    replies: 1120,
    author: "装机老哥",
    time: "2 小时前",
  },
  {
    id: 6,
    title: "毕业季宿舍楼下的告白，主角却说没这回事",
    excerpt: "一段表白视频被全网疯转，当事人亲自下场澄清，围观群众直呼剧情太刺激。",
    tag: "生活",
    heat: 390000,
    replies: 908,
    author: "路过看热闹",
    time: "3 小时前",
    badge: "新",
  },
];

export const rankItems: RankItem[] = [
  { id: 1, title: "恋综大结局在线蹲守楼", desc: "今晚八点正式揭晓，你站哪一对？", heat: 1280, trend: "up", tag: "恋综" },
  { id: 2, title: "热播剧第 38 集剧透楼", desc: "仅限已追到最新进度的小伙伴进楼，前方剧透预警。", heat: 1120, trend: "up", tag: "剧组" },
  { id: 3, title: "上班摸鱼搭子互认现场", desc: "坐标备注，让摸鱼搭子找到你。", heat: 986, trend: "flat", tag: "职场" },
  { id: 4, title: "新机首发数据真实吗", desc: "实测党与参数党现场对线。", heat: 874, trend: "new", tag: "数码" },
  { id: 5, title: "毕业季表白名场面盘点", desc: "那些年我们见证过的青涩告白。", heat: 812, trend: "up", tag: "生活" },
  { id: 6, title: "选秀复活名额争夺战", desc: "还剩最后一小时，粉丝冲刺中。", heat: 743, trend: "down", tag: "综艺" },
  { id: 7, title: "片场偶遇的冷知识", desc: "剧组的门道，比剧还有意思。", heat: 611, trend: "flat", tag: "剧组" },
  { id: 8, title: "周末综艺下饭推荐", desc: "一人一部，进来安利你最近的快乐源泉。", heat: 540, trend: "flat", tag: "综艺" },
  { id: 9, title: "办公室便利贴文学收集", desc: "工位上的小幽默，笑到打工人共鸣。", heat: 489, trend: "up", tag: "职场" },
  { id: 10, title: "手机相册里最值钱的一张", desc: "存了很久舍不得删的照片都有故事。", heat: 402, trend: "down", tag: "生活" },
];

export const threads: Thread[] = [
  {
    id: 1,
    title: "今晚恋综大结局，有一起蹲直播楼的吗",
    excerpt: "坐标八点档，边吃晚饭边看，在线等反转，欢迎一起刷屏吐槽。",
    tag: "恋综",
    author: "不吃宵夜睡不着",
    time: "12 分钟前",
    replies: 128,
    likes: 356,
    views: 5420,
    pinned: true,
  },
  {
    id: 2,
    title: "新剧预告片里这个镜头，是不是致敬了经典？",
    excerpt: "看到第一帧我就觉得眼熟，放一张对比图，评论区来鉴定。",
    tag: "剧组",
    author: "细节控本控",
    time: "36 分钟前",
    replies: 89,
    likes: 203,
    views: 3180,
  },
  {
    id: 3,
    title: "工位摸鱼五分钟，同事们都在聊什么话题",
    excerpt: "午休时间去打水，发现茶水间比热搜还热闹，进来抄作业。",
    tag: "职场",
    author: "今日份咖啡",
    time: "58 分钟前",
    replies: 156,
    likes: 402,
    views: 6200,
  },
  {
    id: 4,
    title: "晒一晒你最近追的下饭综艺",
    excerpt: "求安利！最近剧荒综艺荒，评论区各凭本事种菜。",
    tag: "综艺",
    author: "沙发土豆",
    time: "1 小时前",
    replies: 210,
    likes: 533,
    views: 8100,
  },
  {
    id: 5,
    title: "新手机到手第一件事，大家都装了什么",
    excerpt: "分享你的必装应用和桌面美化，给准备换机的朋友参考。",
    tag: "数码",
    author: "折腾型玩家",
    time: "2 小时前",
    replies: 67,
    likes: 148,
    views: 2360,
  },
  {
    id: 6,
    title: "毕业那年的告白，后来怎么样了",
    excerpt: "宿舍楼下那个喊话的晚上，成了我们共同的青春记忆，进来讲讲你的故事。",
    tag: "生活",
    author: "青回小分队",
    time: "3 小时前",
    replies: 184,
    likes: 466,
    views: 7050,
  },
];

export const hotComments: Comment[] = [
  {
    id: 1,
    name: "西瓜籽本籽",
    text: "蹲了三个月，这瓜终于熟透了，今晚结果一出我直接原地起飞。",
    likes: 3240,
    time: "12 分钟前",
    tag: "恋综",
    initial: "西",
    tone: "primary",
  },
  {
    id: 2,
    name: "剧组打工人",
    text: "作为现场围观过的人说一句，正片只会比路透更炸，信我。",
    likes: 2180,
    time: "30 分钟前",
    tag: "剧组",
    initial: "剧",
    tone: "accent",
  },
  {
    id: 3,
    name: "不加班承诺书",
    text: "不是，这剧情走向我上班摸鱼看都得憋着笑，老板经过我都装正经。",
    likes: 1866,
    time: "1 小时前",
    tag: "职场",
    initial: "不",
    tone: "secondary",
  },
  {
    id: 4,
    name: "今晚加鸡腿",
    text: "投票就差临门一脚了，家人们把最后一票投给谁，评论区给个准话！",
    likes: 1502,
    time: "1 小时前",
    tag: "综艺",
    initial: "今",
    tone: "primary",
  },
  {
    id: 5,
    name: "细节解剖师",
    text: "我把那段慢放了三遍，那个镜头绝对是在致敬经典，同款粉丝请举手。",
    likes: 1340,
    time: "2 小时前",
    tag: "剧组",
    initial: "细",
    tone: "secondary",
  },
];

export const faqs: Faq[] = [
  {
    q: "什么是“吃瓜”？在这里可以做什么？",
    a: "吃瓜就是围观、讨论新鲜有趣话题的通俗说法。在每日有瓜，你可以浏览实时更新的热议现场，查看大家怎么看的热门帖子，也能参与讨论区互动、在评论区发表自己的看法。",
  },
  {
    q: "这里的“今日热点”多久更新一次？",
    a: "热点榜由站内活跃度实时生成，热门话题、讨论区和评论区都会滚动刷新。通常几分钟内就能看到最新动态，越热闹的话题排名上升越快。",
  },
  {
    q: "我可以自己发起话题讨论吗？",
    a: "可以。你在讨论区看到感兴趣的主题都能直接参与回复；未来开通账号后，还可以一键发起新话题，把你想聊的瓜抛给大家。",
  },
  {
    q: "讨论内容有规则约束吗？",
    a: "有。我们希望这里是轻松、友善、就事论事的聚集地。请理性讨论、不人身攻击、不造谣传谣。站方会对违规言论和恶意引战内容进行处理，维护清朗的讨论氛围。",
  },
  {
    q: "如何订阅每日瓜报，不错过热榜？",
    a: "在页面下方填写邮箱并选择你感兴趣的分类，即可订阅每日瓜报。我们会把当日热议话题整理成摘要准时送达，退订也很简单。",
  },
];

export const testimonials = [
  { name: "爱吃瓜的柠檬", role: "每天通勤看", text: "挤地铁刷这个，几站路不知不觉就到了，大家都好会聊。" },
  { name: "人间清醒", role: "深夜蹲点", text: "追剧 + 讨论两不误，评论区人才辈出，比正片还有意思。" },
  { name: "围观群众甲", role: "纯路转粉", text: "以前只会吃现成瓜，现在知道怎么追热点了，爽。" },
];